export default __webpack_public_path__ + "static/media/baseball-player-bg.fd466f78.png";